import { graphql } from '../graphql';

export const accountQuery = graphql(`
  query Account {
    account {
      email
      followedPropertiesV2 {
        _id
        followedProperties {
          id
          relationship
        }
      }
      lockeId
      recentSearchesV2 {
        recentSearches {
          key
          title
          slug
          type
          propertyStatus {
            label
            value
          }
          price
          propertyFeatures {
            iconNameV2
            title
            hoverTitle
            valueWithUnit
          }
        }
      }
    }
  }
`);
